export default "__VITE_ASSET__Br9xj_I3__"